var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoAdt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "278px",
    height: "278px",
    viewBox: "0 0 278 278",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo / ADT") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo-/-ADT",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "page-1",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#0061AA",
    points: "81.312 0 0 81.26 0 196.267 81.312 277.527 196.212 277.527 277.525 196.267 277.525 81.26 196.212 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "211.29 113.301 211.29 183.694 191.7 183.694 191.7 113.301 165.21 113.301 165.21 94.085 238.007 94.085 238.007 113.301"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.29,113.301 L211.29,183.694 L191.7,183.694 L191.7,113.301 L165.21,113.301 L165.21,94.085 L238.007,94.085 L238.007,113.301 L211.29,113.301 Z M85.324,135.685 L74.914,155.893 L95.61,155.893 L85.323,135.685 L85.324,135.685 Z M109.818,183.694 L105.164,174.508 L65.484,174.508 L60.707,183.694 L39.518,183.694 L85.324,94.044 L131.006,183.694 L109.818,183.694 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.35,163.978 L131.482,163.978 L131.482,113.422 L142.351,113.422 C157.265,113.422 167.881,123.66 167.881,138.7 C167.881,153.74 157.265,163.978 142.351,163.978 M182.161,116.801 L161.71,116.801 L161.71,97.835 C155.906,95.255 149.37,93.832 142.35,93.832 L111.89,93.832 L111.89,138.472 L134.124,182.105 L134.934,183.695 L142.351,183.695 C168.134,183.695 187.471,164.609 187.471,138.7 C187.471,130.614 185.568,123.187 182.161,116.8",
    id: "Shape",
    fill: "#FFFFFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAdt);
export default __webpack_public_path__ + "static/media/logo_ ADT.225d2f819abdf1df4b4f87e1daab360b.svg";
export { ForwardRef as ReactComponent };